interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const schemaItems = items.map((item, index) => ({
    "@type": "ListItem" as const,
    position: index + 1,
    item: {
      "@id": item.href ? `https://naruto-manga.com${item.href}` : window.location.href,
      name: item.label,
    },
  }));

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: schemaItems,
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }}
      />
      <nav aria-label="面包屑导航" className="flex items-center text-sm text-foreground-600 py-3">
        {items.map((item, index) => (
          <span key={index} className="flex items-center">
            {index > 0 && (
              <i className="ri-arrow-right-s-line mx-2 text-foreground-400"></i>
            )}
            {item.href ? (
              <a
                href={item.href}
                className="hover:text-primary-500 transition-colors whitespace-nowrap"
              >
                {item.label}
              </a>
            ) : (
              <span className="text-foreground-900 font-medium whitespace-nowrap">
                {item.label}
              </span>
            )}
          </span>
        ))}
      </nav>
    </>
  );
}